import NapaLogo from '../../assets/napa_logo.png'
import { useNavigate } from 'react-router-dom'
import { LandingStyles } from './LandingStyles'
import { Button } from '@mui/material'
import { getAuthCode } from '../../services/PingAuthService/PingAuthService'
import { setCookie, clearCustomCookies } from '../../helpers/CookieHelper'

const Landing = () => {
  const navigate = useNavigate()

  const handleCos = () => {
    setCookie('isCOS', 'true')
    getAuthCode()
  }

  const handleIso = () => {
    navigate('/SignIn')
    clearCustomCookies()
  }

  return (
    <div>
      <div style={LandingStyles.main}>
        <div style={LandingStyles.content}>
          <img src={NapaLogo} alt="NAPA Logo" style={LandingStyles.logo} />
          <h1 style={LandingStyles.brand}>PROTracker</h1>
          <div>
            <Button variant="primary" data-testid="cos-btn" onClick={handleCos}>
              Company Owned Store
            </Button>
          </div>
          <div>
            <Button sx={{ mt: 2 }} variant="primary" data-testid="iso-btn" onClick={handleIso}>
              Independent Owned Store
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Landing
